module.exports = __webpack_public_path__ + "static/leaving-a-mark-in-the-marvel-universe-8bd9a0d68e4f2f33cb959345c19bf9fd.jpg";